// src/components/ToastContainer.js
import React from 'react';
import { useSelector } from 'react-redux';
import Toast from './Toast';

const ToastContainer = () => {
  const toasts = useSelector(state => state.toast);

  return (
    <div className="fixed bottom-[50px] right-4 space-y-2 z-[10000]">
      {toasts.map(toast => (
        <Toast key={toast.id} id={toast.id} message={toast.message} isError={toast.isError} />
      ))}
    </div>
  );
};

export default ToastContainer;
